import React from 'react';
import { Image } from 'react-konva';
import Annotation from 'components/main/images/Annotation.png';

export default function Annotations(props) {
  const drawImage = () => {
    const imageObj = new window.Image();
    imageObj.src = Annotation;
    const { loc } = props;
    return (
      <Image
        id='annotations-img'
        x={loc.x + props.index * props.iconwidth}
        y={loc.y + loc.h - props.iconheight}
        image={imageObj}
        width={props.iconwidth}
        height={props.iconheight}
      />
    );
  };

  return drawImage();
}
